import React from "react";
import {Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";

function ImageSliders(props) {
  const images = props.images || [];
  return (
    <>
      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        {images.map((imgs, index) => (
          <SwiperSlide key={index}>
            <img src={imgs} alt={index} />
          </SwiperSlide>
        ))}
        x
      </Swiper>
    </>
  );
}
export default React.memo(ImageSliders);
